import React from "react";
import { TextField, Grid, Button, Typography, MenuItem, IconButton, Box, Stack } from "@mui/material";
import { Add, Close } from "@mui/icons-material";
import { banques } from "../../asset/variables";

export default function ChequesForm(props) {

    return(
        <Box display="flex" flexDirection="column" rowGap={2}>
            {props.repartition.map((piece, index) =>
            <Box key={index} display="flex" flexDirection="column" rowGap={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    {props.repartition.length>1 && 
                    <IconButton 
                    aria-label="supprimer"
                    sx={{padding:0}} 
                    onClick={()=>{
                        props.setReptotal(old => Number((old-props.repartition[index].montant).toFixed(2)))
                        props.setRepartition(old => old.slice(0, index).concat(old.slice(index+1)))
                    }}>
                        <Close/>
                    </IconButton>
                    }
                    <TextField select fullWidth label={"Banque"} value={piece.banque} size="small"
                    required={typeof props.isdepense ==='boolean' ? false : true}
                    onChange={(e)=> {
                        props.setRepartition(old => old.slice(0, index).concat([{banque: e.target.value, num_cheque:old[index].num_cheque, montant: old[index].montant}].concat(old.slice(index+1))))
                    }}>
                        {banques.map((label, index) => (
                            <MenuItem key={index} value={label}>
                                <Typography>{label}</Typography> 
                            </MenuItem>
                        ))}
                    </TextField>
                </Stack>

                <Stack direction="row" spacing={1}>
                    <TextField size="small"
                    fullWidth
                    required={typeof props.isdepense ==='boolean' ? false : true}
                    label={"Numéro de chèque"}
                    value={piece.num_cheque}
                    helperText={piece.num_cheque.length<6 && piece.num_cheque!=='' ? "Le numéro de chèque doit contenir au moins 6 caractères" : ''}
                    onChange={(e)=> {
                        props.setRepartition(old => old.slice(0, index).concat([{banque: old[index].banque, num_cheque:e.target.value, montant: old[index].montant}].concat(old.slice(index+1))))
                    }}
                    />
                    <TextField size="small" fullWidth required type="number" label="montant" value={piece.montant}
                    slotProps={{ htmlInput: {step:"0.01", min:'0'}, inputLabel: {shrink: true} }}
                    onFocus={()=>{if(piece.montant===0) props.setRepartition(old => {old[index].montant=''; return [...old]})}}
                    onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0){
                        const newTotal = Math.round((props.reptotal-props.repartition[index].montant+Number(e.target.value))*100)/100
                        props.setReptotal(old => newTotal>=0 ? newTotal : 0)
                        props.setRepartition(old => {const update = [...old]; update[index].montant=Number(e.target.value); return update})
                    }else if(e.target.value===''){
                        props.setReptotal(old => old-props.repartition[index].montant)
                        props.setRepartition(old => {const update = [...old]; update[index].montant=''; return update})
                    }}}
                    />
                </Stack>
            </Box>)}

            {(props.isdepense || props.repartition.every(piece => piece.num_cheque!=='')) && props.repartition.every(piece => piece.montant>0) && props.total>props.reptotal &&
            <Button aria-label="ajouter un chèque" fullWidth variant="contained"
            sx={{paddingX:0, width:'100%'}}
            onClick={()=> props.setRepartition(old => old.concat([{banque: '', num_cheque:"", montant:0}]))}>
                <Add sx={{margin:0}}/> Ajouter un chèque
            </Button>}
        </Box>
    )
}